import React, { memo, useCallback } from 'react';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PrimaryButton from '../../Button/PrimaryButton';

const DownloadButton = memo(({ onClick, text = '', className = '', id = '' }) => {
    const handleClick = useCallback((event) => {
        event.preventDefault();
        onClick(event);
    }, [onClick]);

    return (
        <PrimaryButton
            id={id}
            text={text}
            variant="text"
            className={`download-button ${className}`}
            endIcon={<FileDownloadIcon />}
            onClick={handleClick}
            aria-label={text || 'Download'}
        />
    );
});

DownloadButton.displayName = 'DownloadButton';

export default DownloadButton;
